<template>
    <div v-show="showProductDetails" class="dml-lightbox" data-t="12.1">
        <button type="button" class="dml-lightbox__close-wrap" v-on:click="handleClose">
            <div class="dml-lightbox__close">
                <dm-icon name="close" :width="20" :height="20" />
            </div>
        </button>
        <dm-product-details v-if="renderDetailsComponent"
                            ref="productDetails"
                            v-show="!!detailsModel"
                            v-bind="detailsModel"
                            v-on:mounted="handleProductDetailsComponentMounted" />
        <dm-page-preloader v-if="!isProductDetailsComponentMounted"
                           :isLoading="true" />
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import PagePreloader from '../shared/page-preloader-component.vue';
    import IconComponent from '../shared/icon-component.vue';

    import Hub from '../../hub.js';
    import { getQueryParameters, serializeParameters } from '../../utils/url.js';
    import { SIZES } from '../../utils/screen-sizes';
    import * as types from '../../store/types.js';

    const ProductDetailsComponent = () => import(/* webpackChunkName: "lightbox" */ '../product-list/product-details-component.vue');

    export default {
        name: 'dm-lightbox',
        components: {
            'dm-product-details': ProductDetailsComponent,
            'dm-page-preloader': PagePreloader,
            'dm-icon': IconComponent,
        },
        computed: {
            ...mapGetters([
                'detailsModel',
                'currentProductId',
            ]),
            showProductDetails() {
                return !!this.currentProductId;
            },
        },
        data: () => ({
            renderDetailsComponent: false,
            isProductDetailsComponentMounted: false
        }),
        created() {
            this.unwatchRenderDetailsComponent = this.$watch('currentProductId', (val) => {
                if (val) {
                    this.renderDetailsComponent = true;
                    this.unwatchRenderDetailsComponent();
                }
            });
        },
        mounted() {
            this.$pageWrap = document.querySelector('.js-page-wrap');
        },
        methods: {
            handleClose() {
                const queryParameters = getQueryParameters(window.location.search);
                const locationPathName = window.location.pathname;
                delete queryParameters['pr'];
                delete queryParameters['pid'];

                const isQueryEmpty = Object.keys(queryParameters).length === 0;
                const query = isQueryEmpty ? '' : `?${serializeParameters(queryParameters)}`
                const url = `${locationPathName}${query}`;
                window.history.pushState(null, null, url);

                this.$store.dispatch(types.PRODUCT_DETAILS_HIDE);

                const category = window.innerWidth >= SIZES.LARGE ? 'd_lightbox' : 'm_lightbox';
                this.$ga.trackEvent({
                    category,
                    action: 'click',
                    label: 'close'
                });
            },
            handleProductDetailsComponentMounted() {
                this.isProductDetailsComponentMounted = true;
            },
            addListeners() {
                this.$pageWrap.addEventListener('click', this.clickOutsideHandler, true);
                document.addEventListener('keydown', this.keydownHandler);
            },
            removeListeners() {
                this.$pageWrap.removeEventListener('click', this.clickOutsideHandler, true);
                document.removeEventListener('keydown', this.keydownHandler);
            },
            clickOutsideHandler(e) {
                this.handleClose();
            },
            keydownHandler(e) {
                if (e.code === 'Escape') {
                    this.handleClose();
                }
            }
        },
        watch: {
            currentProductId(id, oldId) {
                if (id) {
                    if (!oldId) {
                        this.scrollY = window.scrollY;
                        Hub.publish(Hub.DRAWER_OPEN);
                        this.addListeners();
                    } else {
                        this.$refs.productDetails.$el.scrollTo(0, 0)
                    }

                    if (window.innerWidth < SIZES.LARGE) {
                        window.scrollTo(0, 0);
                    } else {
                        this.$pageWrap.style.position = 'fixed';
                        this.$pageWrap.style.top = `-${this.scrollY}px`;
                    }
                } else if (oldId) {
                    Hub.publish(Hub.DRAWER_CLOSE);

                    if (window.innerWidth >= SIZES.LARGE) {
                        this.$pageWrap.style.position = '';
                        this.$pageWrap.style.top = '';
                    }

                    window.scrollTo(0, this.scrollY);
                    this.removeListeners();
                }
            },
        }
    };
</script>
